import React, { useContext, useEffect, useState } from "react";
import "./Offer_Products.css";
import Common_Heading_Holder from "../../Common-Component/common_heading_holder/Common_Heading_Holder";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import Product_Info_Card from "../../Common-Component/product_info_card/Product_Info_Card";
import { ProductDetail } from "../../../utils/apis/Product/Product";
import { Context } from "../../../utils/context";
import { getData } from "../../../utils/api";

const Offer_Products = () => {
  const { IMG_URL, shimmerLoader, setShimmerLoader, currentLocation } =
    useContext(Context);
  const [offerproduct, setofferproduct] = useState([]);

  const getProduct = async () => {
    const city =
      currentLocation?.city ||
      currentLocation?.formatted_address ||
      currentLocation?.address_components?.[0]?.long_name ||
      "";
    if (city) {
      setShimmerLoader(true);
      const res = await getData(
        `/without-login/product/offer-product?city=${city}`,
      );
      if (res?.success) {
        setofferproduct(res?.data);
      }
      setShimmerLoader(false);
    }
  };

  useEffect(() => {
    getProduct();
  }, [currentLocation]);

  return (
    <section className="Offer_Products">
      {offerproduct?.length > 0 && (
        <>
          {" "}
          <Common_Heading_Holder headingText={"Offer Products"} />
          <div className="main_swiper_div">
            <Swiper
              spaceBetween={15}
              pagination={{
                dynamicBullets: true,
                clickable: true,
              }}
              modules={[Pagination]}
              autoplay={{ delay: 300 }}
              className="common_swiper"
              breakpoints={{
                0: { slidesPerView: 1, spaceBetween: 5 },
                380: { slidesPerView: 1.5, spaceBetween: 5 },
                480: { slidesPerView: 1.5 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 2 },
                1200: { slidesPerView: 3 },
                1400: { slidesPerView: 4 },
              }}
            >
              {offerproduct?.map((item) => (
                <SwiperSlide key={item?.id}>
                  <Product_Info_Card
                    item={item}
                    product={item?.product}
                    showQty
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </>
      )}
    </section>
  );
};

export default Offer_Products;
